<template>
    <div class="loan-detail-table">
        <el-table :data="datas" style="width: 100%" class="row-click ah-el-data-table" v-loading="loading" @row-click="onRowClick">
            <el-table-column prop="drawdownDate" label="動撥日期" align="left" width="110">
                <template slot-scope="scope">
                    <div>{{ scope.row.drawdownDate | dateFormater("YYYY-MM-dd") }}</div>
                    <div><span v-if="isReserve(scope.row.drawdownDate)" class="reserved">預約</span></div>
                </template>
            </el-table-column>
            <el-table-column prop="systemNo" label="動撥摘要" min-width="200">
                <template slot-scope="scope">
                    <div class="description-block">
                        <div class="description">
                            <strong><span v-if="scope.row.isMakeUpRegistration">[補登]</span> {{ scope.row.summary }}</strong>
                        </div>
                        <!-- <div class="system-no">{{ scope.row.systemNo }}</div> -->

                        <!-- <div>動撥日：{{ scope.row.drawdownDate | dateFormater("YYYY-MM-dd") }}</div> -->
                        <div v-if="scope.row.repaymentWay == 2" style="padding: 5px 0;">
                            <div style="font-size: 9pt; color: #888">
                                <span>還款進度：</span>
                                <span>{{ getPercentage(scope.row) }}%</span>
                            </div>
                            <el-progress :percentage="getPercentage(scope.row)" :show-text="false" :color="getPercentage(scope.row) === 100 ? '#92DE56' : '#463cb2'" :stroke-width="7"></el-progress>
                        </div>
                        <div v-if="scope.row.repaymentWay == 1" style="padding: 5px 0;">
                            <div style="font-size: 9pt; color: #888">還款到期日：{{ getRepaymentDueDate(scope.row.drawdownDate) }}</div>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="customNumber" label="動撥金額" align="right" width="145">
                <template slot-scope="scope">
                    <div class="amt-block">
                        <div class="main-block">
                            <Money :v="scope.row.amount" />
                        </div>
                        <div class="sub-block" v-if="!scope.row.isMakeUpRegistration">
                            <div class="label">信保費：</div>
                            <div class="value"><Money :v="scope.row.feE_CD_AMT" /></div>
                        </div>
                        <div class="sub-block" v-if="!scope.row.isMakeUpRegistration">
                            <div class="label">信貸手續費：</div>
                            <div class="value"><Money :v="scope.row.feE_HAND_AMT" /></div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="foo" label="已還款金額" align="right" width="120">
                <template slot-scope="scope">
                    <Money :v="getTotalRealRePayedAmt(scope.row)" />
                </template>
            </el-table-column>
            <!-- <el-table-column prop="description" label="還款進度" align="right" width="100">
                <template slot-scope="scope">
                    <div v-if="scope.row.repaymentWay === 2" class="progress-block">
                        <div>{{ getPercentage(scope.row) }}%</div>
                        <el-progress
                            :percentage="getPercentage(scope.row)"
                            :show-text="false"
                            :color="getPercentage(scope.row) === 100 ? '#92DE56' : '#463cb2'"
                            :stroke-width="10"
                        ></el-progress>
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="foO_DAT" label="存入帳戶" width="130" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.isMakeUpRegistration">--</div>
                    <div v-else>{{ scope.row.depositorBankName }}</div>
                </template>
            </el-table-column>

            <!-- <el-table-column align="center" width="80">
                <template slot-scope="scope">
                    <el-button size="small" @click="onEditDrawRequest(scope.row)">編輯</el-button>
                </template>
            </el-table-column> -->
            <el-table-column align="center" width="170">
                <template slot-scope="scope">
                    <el-button size="small" @click="onRowClick(scope.row)">明細</el-button>
                    <el-button v-if="isRepayComplete(scope.row)" size="small" type="success" plain disabled>已還清</el-button>
                    <el-button v-else size="small" type="primary" @click="onAddReturn($event, scope.row)">還款繳息</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import SubTable from './LoanDetailSubTableView.vue';

export default {
    components: { SubTable },
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        repaymentPeriods: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        onEditDrawRequest(data) {
            this.$emit('open', { type: 'edit-draw-request', data });
        },
        onAddReturn(event, data) {
            this.$emit('open', { type: 'add-return', data });
            event.preventDefault();
            event.stopPropagation();
        },
        onEditReturn($event) {
            this.$emit('open', $event);
        },
        getTotalRealRePayedAmt(row) {
            const NON_RESERVE_LIST = _.filter(row.repaymentList, (o) => o.repaymentDate <= +new Date());
            return _.sumBy(NON_RESERVE_LIST, 'principalAmount');
        },
        getPercentage(row) {
            return Math.round(((this.getTotalRealRePayedAmt(row) / row.amount) * 1000) / 10);
        },
        isReserve(date) {
            return date > +new Date();
        },
        isRepayComplete(row) {
            return (
                _.sumBy(
                    _.filter(row.repaymentList, (x) => x.repaymentDate <= +new Date()),
                    'principalAmount',
                ) === row.amount
            );
        },
        onRowClick(row) {
            console.log(row);
            this.$emit('row-click', row);
        },
        getRepaymentDueDate(drawdownDate) {
            if (drawdownDate) {
                return moment(drawdownDate)
                    .add(this.repaymentPeriods, 'day')
                    .format('YYYY-MM-DD');
            }
            return '';
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.loan-detail-table {
    td {
        vertical-align: top;
    }
    .loan-complete {
        margin-top: 5px;
        color: #1ed700;
        font-weight: bold;
    }
    .description-block .type {
        color: $main-color;
    }
    .system-no {
        font-size: 9pt;
        color: #888;
    }
    .amt-block {
        .main-block {
            margin-bottom: 10px;
        }
        .sub-block {
            display: flex;
            justify-content: right;
            color: #888;
            font-size: 9pt;
            line-height: 20px;
        }
    }
    .progress-block > *:first-child {
        font-weight: bold;
    }
    .reserved {
        color: orange;
        font-size: 9pt;
        padding: 2px 5px;
        border-radius: 4px;
        border: 1px solid orange;
        // margin-left: 5px;
    }
}
</style>
